import { formatDate } from 'buzz_lib_shared';
export const defaultDateFormatter = date => {
  return !!date ? formatDate(date) : '';
};